import React from "react";
import { Navigate } from "react-router-dom";
import { PERMISSION } from "common/permission";
import { useLocation } from 'react-router-dom';

const Authmiddleware = (props) => {
  if (!localStorage.getItem("tokens")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  if (localStorage.getItem("tokens")) {
    const { roleName } = JSON.parse(localStorage.getItem("user"))
    const location = useLocation();
    const currentPath = location.pathname;
    if (currentPath == '/' && roleName == 'it_admin') {
      return (
        <Navigate to={{ pathname: "/it_admin/users", state: { from: props.location } }} />
      )
    } else if (currentPath == '/' && roleName == 'dealer') {
      return (
        <Navigate to={{ pathname: "/customer/dashboards", state: { from: props.location } }} />
      )
    } else if (currentPath == '/') {
      return (
        <Navigate to={{ pathname: `/${roleName}/dashboard`, state: { from: props.location } }} />
      )
    }
  }

  const { route: { permission, action } } = props
  if (permission && action) {
    const isPagePermission = isPagePermissionExist(permission, action)
    if (!isPagePermission) {
      return (
        <Navigate to={{ pathname: "/forbidden-zone", state: { from: props.location } }} />
      );
    }
  }

  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

const isPagePermissionExist = (permission, action) => {

  const permissionsStr = localStorage.getItem("permissions")
  try {
    const rolesPermission = JSON.parse(permissionsStr);
    const pagePermission = rolesPermission.find(p => p.permission_name == permission)
    return pagePermission && pagePermission[action] == PERMISSION.PERMISSION_STATUS.ALLOWED
  } catch (error) {
    return false

  }

}


export default Authmiddleware;
